/* eslint-disable i18next/no-literal-string -- css not user facing text */
import { defineSlotRecipe } from '@chakra-ui/react';

export const toast = defineSlotRecipe({
  slots: ['root', 'title', 'description', 'indicator', 'actionTrigger', ' closeTrigger'],
  className: 'chakra-toast',
  base: {
    root: {
      minWidth: 80,
      maxWidth: 120,
      py: '3',
      ps: '4',
      pe: '4',
      bg: 'blue.50',
      color: 'gray.fg',
      '&[data-type=warning]': {
        bg: 'orange.50',
      },
      '&[data-type=success]': {
        bg: 'on-lime.50',
      },
      '&[data-type=error]': {
        bg: 'red.50',
      },
    },
    title: {
      fontWeight: 'bold',
      textStyle: 'md',

      color: 'gray.fg',
    },
    description: {
      textStyle: 'md',
      opacity: '1',
      color: 'gray.fg',
    },
    indicator: {
      boxSize: '6',
    },
  },
});
